import { useAuth } from '@/features/auth/hooks/useAuth';

export const useAdminAccess = () => {
  const { user } = useAuth();

  // Defensive: roles should always be an array but can be undefined if relation not loaded
  if (user && !user.roles) {
    console.warn('User object exists but roles are undefined - this indicates a backend data loading issue', user);
  }

  // Ensure roles is always an array to prevent .filter() errors
  const roles = user?.roles || [];

  const adminRoles = roles.filter(
    (r) =>
      r.role === 'SYSTEM_ADMIN' ||
      r.role === 'AUCTION_HOUSE_ADMIN' ||
      r.role === 'AUCTION_HOUSE_WORKER'
  );

  const isAdmin = adminRoles.length > 0;

  const adminAuctionHouses = [
    ...new Set(
      adminRoles
        .filter((r) => r.auctionHouseId)
        .map((r) => r.auctionHouseId!)
    ),
  ];

  const isSystemAdmin = adminRoles.some((r) => r.role === 'SYSTEM_ADMIN');

  return { isAdmin, adminAuctionHouses, adminRoles, isSystemAdmin };
};
